<form [formGroup]="form">
  <div class="gap-lg flex flex-col" formArrayName="phases">
    @for (form of phasesForm.controls; track $index; let idx = $index) {
      <app-expansion-panel [titre]="'Phase ' + (idx + 1)" [item]="form" [isOpen]="true">
        <div class="px-lg pt-lg pb-xl" [formGroupName]="idx" hlmField>
          <label for="nom" hlmFieldLabel labelRequired>Nom de la phase</label>
          <input id="nom" hlmInput formControlName="nom" />
          @if (form.get('nom')?.hasError('required') && form.touched) {
            <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
          }
          @if (form.get('nom')?.hasError('notUnique')) {
            <hlm-field-error>Cette phase existe déjà</hlm-field-error>
          }
        </div>
      </app-expansion-panel>
    }
    <app-button-add-new (click)="addPhase()" label="Ajouter une phase" />
  </div>
</form>
